import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import TranslationContainer from '../../../containers/elements/translation/TranslationContainer';

class Translation extends Component {
    constructor(props) {
        super(props);

        this.handleEditTranslation = this.handleEditTranslation.bind(this);
        this.handleDeleteTranslation = this.handleDeleteTranslation.bind(this);
    }

    handleEditTranslation() {
        const {translation} = this.props;
        this.props.openDialogEditTranslation(translation.id, translation.fullKey, (translation.strings.de ? translation.strings.de.value : ''), (translation.strings.en ? translation.strings.en.value : ''), translation.translationType);
    }

    handleDeleteTranslation() {
        const {translation, t} = this.props;
        swal({
            title: t('translation.delete.really.title'),
            text: t('translation.delete.really.text', {key: translation.key}),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDelete) =>{
            if(reallyDelete) {
                this.props.deleteTranslation(translation.id);
            }
        })
    }

    render() {
        const {translation} = this.props;
        return (
            <div className="translation">
                <div className={"translation-content type-" + translation.type}>
                    {translation.fullKey}
                    {translation.type === 'translation' ? (
                        <div className="strings pull-right">
                            <div className="lang lang-de">
                                {translation.strings.de ? (
                                    translation.strings.de.value.length > 30 ? translation.strings.de.value.substr(0, 30) + "..." : translation.strings.de.value
                                ): ''}
                            </div>
                            <div className="lang lang-en">
                                {translation.strings.en ? (
                                    translation.strings.en.value.length > 30 ? translation.strings.en.value.substr(0, 30) + "..." : translation.strings.en.value
                                ): ''}
                            </div>
                            <div className="btn-group btn-group-sm">
                                <button className="btn btn-sm btn-primary" onClick={this.handleEditTranslation}>
                                    <span className="fa fa-pencil"/>
                                </button>
                                <button className="btn btn-sm btn-danger" onClick={this.handleDeleteTranslation}>
                                    <span className="fa fa-trash"/>
                                </button>
                            </div>
                        </div>
                    ):null}
                    <div className="clearfix"/>
                </div>
                {translation.children ? translation.children.map((translation, i) => (
                    translation.visible ? (
                        <TranslationContainer translation={translation} key={i}/>
                    ) : null
                )) : null}
            </div>
        )
    }
}

export default translate()(Translation);